var layout = {
  layoutFullWidth: 1440,
  layoutMinWidth: 1280,
  layoutGutter: 24,
  layoutCol1: 93,
  layoutCol2: 210,
  layoutCol3: 327,
  layoutCol4: 445,
  layoutCol6: 680,
  layoutCol12: 1384
};
export default layout;